export const APP_TITLE = 'Ecoprotec Product Selector';
export const API_URL = 'https://api.ecoproductselector.com/v1/';
export const MEDIA_URL = 'https://api.ecoproductselector.com/app/uploads/';



// WEBPACK FOOTER //
// ./src/constants/config.js